const templateType = {
  TEMPLATE_AUDIENCE: 'audience',
  TEMPLATE_TEST: 'test',
};

export default templateType;
